import type { FC } from 'react';
import { useVetAdviceModal } from '@application/components';
import { useRouter } from '@application/utils';
import { FaWhatsapp } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';
import { BREAKPOINTS } from '@presentation/styles';
import { Analytics } from '@application/utils/analytics';
import dogImage from './assets/dog.webp';
import { Banner } from '../Banner';
import bannerBackgroundImage from './assets/banner-bg.svg';
import type { VetAdviceBannerProps } from './types';

export * from './types';

export const VetAdviceBanner: FC<VetAdviceBannerProps> = (props) => {
  const { hideImage = false } = props;
  const { modalHook: vetAdviceModalHook } = useVetAdviceModal();
  const { translate } = useRouter();

  const buttonLabel = translate('common.banners.vetAdvice.cta');
  const title = translate('common.banners.vetAdvice.title');
  const isMobile = useMediaQuery({ query: `(max-width: ${BREAKPOINTS.phone}px)` });

  return (
    <Banner
      title={title}
      btnText={buttonLabel}
      theme="blue"
      backgroundImage={bannerBackgroundImage}
      image={hideImage ? undefined : dogImage}
      iconLeft={<FaWhatsapp size={20} />}
      onClick={() => {
        Analytics.sendClickOnVetAdviceBanner();
        vetAdviceModalHook.show();
      }}
      breakSpaces={isMobile}
    />
  );
};
